import { useEffect, useRef } from "react";

// Registro global de callbacks de recarga. Un único GlobalPullToRefresh
// (en App.jsx) dispara `runRefreshCallbacks()` cuando el usuario tira hacia
// abajo en el tope de la página. Cada página dinámica registra su función de
// carga vía `useRefreshListener(load)` — sin necesidad de envolver su contenido
// en <PullToRefresh>. Las páginas estáticas simplemente no registran callback.
const callbacks = new Set();

export function runRefreshCallbacks() {
  return Promise.allSettled([...callbacks].map((fn) => fn()));
}

// Hook: registra `fn` como callback de recarga global. `fn` se lee vía ref así
// la suscripción es estable (empty deps) y siempre ejecuta la versión más fresca.
export default function useRefreshListener(fn) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    const cb = () => ref.current?.();
    callbacks.add(cb);
    return () => callbacks.delete(cb);
  }, []);
}